import type { Map as LeafletMap } from "leaflet";
import { type RefObject, useEffect } from "react";

const RESIZE_TRANSITION_DELAY_MS = 320;

export function useInvalidateMapSizeOnPanelToggle(
	mapRef: RefObject<LeafletMap | null>,
	isVehiclesModalOpen: boolean,
	isFencesModalOpen: boolean
) {
	// biome-ignore lint/correctness/useExhaustiveDependencies: re-run whenever a side panel opens/closes so the map recalculates its size; mapRef is a stable ref and invalidateSize is read fresh from it
	useEffect(() => {
		const timeout = setTimeout(() => {
			mapRef.current?.invalidateSize();
		}, RESIZE_TRANSITION_DELAY_MS);

		return () => clearTimeout(timeout);
	}, [isVehiclesModalOpen, isFencesModalOpen]);
}
